import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'BlogRichText',
})(({ breakpoints, spacing }) => ({
  blogRichText: {
    margin: `${spacing(1)} 0`,

    [breakpoints.up('md')]: {
      margin: `${spacing(2)} 0`,
    },
  },
  richTextParagraph: {
    wordBreak: 'break-word',
  },
  richTextList: {
    listStylePosition: 'inside',
    padding: 0,
    '& p': {
      display: 'inline',
    },
  },
  richTextContent: {
    margin: `${spacing(2)} 0`,
  },
  fixedGrid: {
    [breakpoints.up('lg')]: {
      margin: 0,
    },
  },
}));

export default useStyles;
